import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Setting } from "../../../shared/setting";

@Injectable({
  providedIn: "root",
})
export class TransationsService {
  constructor(
    private http: HttpClient,
    public setting: Setting
  ) {}

  /**
   * Generic method to fetch data from the API for any entity
   * @param entity The name of the entity (e.g., 'Customers', 'Accounts')
   * @param body The request body object
   * @returns Observable with the API response
   */
  fetchTransactionsHistoryData(id): Observable<any> {
    const body = {
      customer_id: id,
    };
    const url = `${this.setting.APIEndPoint}api/v1/transactions/history`;
    return this.http.post(url, body, { observe: "response" });
  }

  /**
   * Generic method to create a new record in the API
   * @param endpoint The endpoint for the entity (e.g., 'transactions', 'documents')
   * @param data The data to send in the request body
   * @returns Observable with the API response
   */
  createGenericData(endpoint: string, data: any): Observable<any> {
    const url = `${this.setting.APIEndPoint}api/v1/${endpoint}`;
    return this.http.post(url, data, { observe: "response" });
  }

  printTransactionsHistoryData(transactions, customer): Observable<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Accept: "application/pdf",
    });

    const body = {
      transactions: transactions,
      customer: customer,
    };

    console.log("printTransactionsHistoryData");
    const url = `${this.setting.APIEndPoint}api/v1/reports/customer-report`;
    return this.http.post(url, body, { responseType: "blob" });
  }

  printConsolidate(): Observable<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Accept: "application/pdf",
    });

    console.log("printTransactionsHistoryData");
    const url = `${this.setting.APIEndPoint}api/v1/reports/consolidate-report`;
    return this.http.post(url, null, { responseType: "blob" });
  }

  fetchCustomerMonthlyMovements(customerId: number): Observable<any> {
    const url = `${this.setting.APIEndPoint}api/v1/transactions/monthly-movements/${customerId}`;
    return this.http.get(url, { observe: "response" });
  }
  downloadCustomerMovements(customerId: number) {
    const url = `${this.setting.APIEndPoint}api/v1/reports/customer-movements`;
    return this.http.post(url, { customerId }, { responseType: "blob" });
  }
}
